export enum TravelerInfoType {
  PASSENGER = 'PASSENGER',
  GUEST = 'GUEST',
  DRIVER = 'DRIVER',
  PACKAGE_TRAVELER = 'PACKAGE_TRAVELER',
  PERSON = 'PERSON',
}

export enum TravelerTypes {
  ADULTS = 'ADULTS',
  CHILDREN = 'CHILDREN',
  INFANTS = 'INFANTS'
}
